<template>
  <div class="HeaderTop">
    <div class="top-main">
      <div class="top-left">
        <i class="iconfont icon-a-weizhidingwei icon-one"></i>
        <span class="mini-text">{{ $t("adress") }}</span>
        <i class="iconfont icon-dianhua1 icon-one"></i>
        <span class="mini-text">+86 193 0573 0833</span>
        <i class="iconfont icon-a-xinfengyoujianxiang icon-one"></i>
        <span class="mini-text">info@haikangborui.com</span>
      </div>
      <div class="top-right" @click="toggleDropdown">
        <i class="iconfont icon-a-quanqiuhulianwang icon-one"></i>
        <span class="mini-text">{{ currentLanguage }}</span>
        <i class="iconfont icon-xiala icon-two"></i>
        <div v-if="isDropdownOpen" class="dropdown">
          <div
            v-for="lang in languages"
            :key="lang.id"
            @click="selectLanguage(lang.id, $event)"
          >
            {{ lang.translation }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: "HeaderTop",
  data() {
    return {
      isDropdownOpen: false,
      currentLanguage: "",
      languageId:'',
      languages: [
        // { value: "en", label: "English" },
        // { value: "zh", label: "中文" },
        // { "value": "ar", "label": "العربية" }
      ],
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectLanguage(value, event) {
      event.stopPropagation();
      const selectedLang = this.languages.find((lang) => lang.id == value);
      this.$i18n.locale = selectedLang.code;
      this.currentLanguage = selectedLang.translation;
      this.isDropdownOpen = false;
      localStorage.setItem("currentLanguage", this.currentLanguage);
      localStorage.setItem('languageId',value)
      this.$store.commit('setLang',value)
    },
  },
  async created() {
    const savedLanguage = localStorage.getItem("languageId");
    let data = await request.get('/hkbr/language/listNoToken')
    this.languages = data
    if (savedLanguage) {
      const selectedLang = this.languages.find(
        (lang) => lang.id == savedLanguage
      );
      this.$i18n.locale = selectedLang.code
      this.currentLanguage = selectedLang ? selectedLang.translation : "English";
      this.$store.commit('setLang',savedLanguage)
    } else {
      this.currentLanguage = "English";
      localStorage.setItem("currentLanguage", this.currentLanguage);
      localStorage.setItem('languageId',2)
      this.$store.commit('setLang',2)
      this.$i18n.locale = 'en';
    }
  },
};
</script>
<style scoped>
.HeaderTop {
  float: left;
  width: 100%;
}
.top-main {
  float: left;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #eeeeee;
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
  box-sizing: border-box;
  color: #595656;
}
.mini-text {
  font-size: 12px;
}
.icon-one {
  color: #acacac;
  margin-right: 5px;
  margin-left: 15px;
}
.icon-two {
  color: #acacac;
  margin-right: 5px;
  margin-left: 5px;
}
.top-right {
  width: 120px;
  cursor: pointer;
}
.dropdown {
  position: absolute;

  padding: 5px;
  min-width: 100px;
  z-index: 1;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #eee;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.dropdown div {
  padding: 5px;
  cursor: pointer;
}

.dropdown div:hover {
  background-color: #f0f0f0;
}
/* 手机端样式调整 */
@media (max-width: 1200px) {
  .top-left {
    display: none;
  }
  .top-main {
    justify-content: end;
  }
  .top-main {
    padding: 0;
  }
}
</style>
